export function docsSiteHref(path = "/docs/public"): string {
  const configured = process.env.NEXT_PUBLIC_DOCS_BASE_URL || process.env.DOCS_BASE_URL || process.env.DOCS_SITE_URL || process.env.STAGING_DOCS_URL || process.env.PROD_DOCS_URL || (process.env.NODE_ENV === "production" ? "https://docs.dronejob.ai" : "http://localhost:3002");
  const base = /^https?:\/\//i.test(configured) ? configured : `https://${configured}`;
  return new URL(path, base).toString();
}
